<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                  <div class="card-header align-items-center border-bottom-dark px-0">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Скидки на категории и бренды
                      </h3>
                    </div>
                    <div class="icons d-flex">
                      <button
                        @click="openModal"
                        class="btn btn-primary"
                        v-if="permissions.includes('discount-manage')"
                      >
                        <i class="fas fa-plus"></i> Добавить скидку
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table table-head-custom table-vertical-center">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Категория</th>
                            <th>Бренд</th>
                            <th>Скидка %</th>
                            <th>Приоритет</th>
                            <th>Мин. кол-во</th>
                            <th>Период</th>
                            <th>Статус</th>
                            <th>Действия</th>
                          </tr>
                        </thead>
                        <tbody v-if="discounts.length > 0">
                          <tr v-for="discount in discounts" :key="discount.id">
                            <td>{{ discount.id }}</td>
                            <td>{{ (discount.category && discount.category.name) || '-' }}</td>
                            <td>{{ (discount.brand && discount.brand.name) || '-' }}</td>
                            <td>{{ discount.percentage }}%</td>
                            <td>{{ discount.priority }}</td>
                            <td>{{ discount.min_quantity || '-' }}</td>
                            <td>
                              <span v-if="discount.date_start || discount.date_end">
                                {{ formatDate(discount.date_start) }} - {{ formatDate(discount.date_end) }}
                              </span>
                              <span v-else>-</span>
                            </td>
                            <td>
                              <span
                                class="badge"
                                :class="discount.status ? 'badge-success' : 'badge-danger'"
                              >
                                {{ discount.status ? 'Активен' : 'Отключен' }}
                              </span>
                            </td>
                            <td>
                              <button
                                @click="editDiscount(discount)"
                                class="btn btn-sm btn-info mr-1"
                                title="Редактировать"
                              >
                                <i class="fas fa-edit"></i>
                              </button>
                              <button
                                @click="toggleStatus(discount)"
                                class="btn btn-sm"
                                :class="discount.status ? 'btn-warning' : 'btn-success'"
                                :title="discount.status ? 'Отключить' : 'Включить'"
                              >
                                <i :class="discount.status ? 'fas fa-toggle-on' : 'fas fa-toggle-off'"></i>
                              </button>
                              <button
                                @click="deleteDiscount(discount)"
                                class="btn btn-sm btn-danger"
                                title="Удалить"
                              >
                                <i class="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="9" class="text-center">Нет скидок</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Add/Edit -->
    <div
      class="modal fade"
      :class="{ 'show': showModal }"
      tabindex="-1"
      role="dialog"
      :style="[showModal ? {'display': 'block'} : {'display': 'none'}]"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEditing ? 'Редактировать скидку' : 'Добавить скидку' }}</h5>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveDiscount">
              <div class="form-group">
                <label>Категория</label>
                <select v-model="form.category_id" class="form-control">
                  <option :value="null">Выберите категорию</option>
                  <option v-for="cat in categories" :key="cat.value" :value="cat.value">
                    {{ cat.label }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Бренд</label>
                <select v-model="form.brand_id" class="form-control">
                  <option :value="null">Выберите бренд</option>
                  <option v-for="brand in brands" :key="brand.value" :value="brand.value">
                    {{ brand.label }}
                  </option>
                </select>
                <small class="text-muted">Укажите категорию ИЛИ бренд (или оба)</small>
              </div>
              <div class="form-group">
                <label>Группа клиентов</label>
                <select v-model="form.customer_group_id" class="form-control">
                  <option :value="0">Все группы</option>
                  <option v-for="group in customerGroups" :key="group.value" :value="group.value">
                    {{ group.label }}
                  </option>
                </select>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Скидка % *</label>
                    <input
                      type="number"
                      v-model.number="form.percentage"
                      class="form-control"
                      min="0"
                      max="100"
                      step="0.01"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Приоритет</label>
                    <input
                      type="number"
                      v-model.number="form.priority"
                      class="form-control"
                      min="1"
                      max="100"
                    />
                    <small class="text-muted">1 = наивысший приоритет</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Мин. кол-во</label>
                    <input
                      type="number"
                      v-model.number="form.min_quantity"
                      class="form-control"
                      min="0"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>
                  <input type="checkbox" v-model="form.affect_parent" />
                  Распространить на родительские категории
                </label>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Дата начала</label>
                    <input type="date" v-model="form.date_start" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Дата окончания</label>
                    <input type="date" v-model="form.date_end" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>
                  <input type="checkbox" v-model="form.status" />
                  Активен
                </label>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Отмена</button>
            <button type="button" @click="saveDiscount" class="btn btn-primary">Сохранить</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Backdrop -->
    <div v-if="showModal" class="modal-backdrop fade show" @click="closeModal"></div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CategoryBrandDiscounts',
  data() {
    return {
      discounts: [],
      categories: [],
      brands: [],
      customerGroups: [],
      form: {
        id: null,
        category_id: null,
        brand_id: null,
        customer_group_id: 0,
        priority: 1,
        percentage: 0,
        affect_parent: false,
        min_quantity: 0,
        status: true,
        date_start: null,
        date_end: null,
      },
      isEditing: false,
      showModal: false,
      permissions: [],
    };
  },
  mounted() {
    this.permissions = this.$parent.permissions || [];
    this.fetchDiscounts();
    this.fetchCategories();
    this.fetchBrands();
    this.fetchCustomerGroups();
  },
  methods: {
    async fetchDiscounts() {
      try {
        const response = await axios.get('/api/admin/category-brand-discounts', {
          headers: this.getAuthHeaders(),
        });
        this.discounts = response.data.data || [];
      } catch (error) {
        console.error('Error fetching discounts:', error);
        this.discounts = [];
      }
    },
    async fetchCategories() {
      try {
        const response = await axios.get('/api/admin/category-brand-discounts-data/categories', {
          headers: this.getAuthHeaders(),
        });
        this.categories = response.data.data || [];
      } catch (error) {
        console.error('Error fetching categories:', error);
        this.categories = [];
      }
    },
    async fetchBrands() {
      try {
        const response = await axios.get('/api/admin/category-brand-discounts-data/brands', {
          headers: this.getAuthHeaders(),
        });
        this.brands = response.data.data || [];
      } catch (error) {
        console.error('Error fetching brands:', error);
        this.brands = [];
      }
    },
    async fetchCustomerGroups() {
      try {
        const response = await axios.get('/api/admin/category-brand-discounts-data/customer-groups', {
          headers: this.getAuthHeaders(),
        });
        this.customerGroups = response.data.data || [];
      } catch (error) {
        console.error('Error fetching customer groups:', error);
        this.customerGroups = [];
      }
    },
    openModal() {
      this.isEditing = false;
      this.resetForm();
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    editDiscount(discount) {
      this.isEditing = true;
      this.form = {
        id: discount.id,
        category_id: discount.category_id,
        brand_id: discount.brand_id,
        customer_group_id: discount.customer_group_id || 0,
        priority: discount.priority,
        percentage: discount.percentage,
        affect_parent: discount.affect_parent,
        min_quantity: discount.min_quantity,
        status: discount.status,
        date_start: discount.date_start,
        date_end: discount.date_end,
      };
      this.showModal = true;
    },
    async saveDiscount() {
      // Validation
      if (!this.form.category_id && !this.form.brand_id) {
        this.showError('Укажите категорию или бренд');
        return;
      }

      try {
        if (this.isEditing) {
          await axios.put(`/api/admin/category-brand-discounts/${this.form.id}`, this.form, {
            headers: this.getAuthHeaders(),
          });
          this.showSuccess('Скидка обновлена');
        } else {
          await axios.post('/api/admin/category-brand-discounts', this.form, {
            headers: this.getAuthHeaders(),
          });
          this.showSuccess('Скидка создана');
        }
        this.closeModal();
        this.fetchDiscounts();
      } catch (error) {
        console.error('Error saving discount:', error);
        this.showError('Ошибка сохранения');
      }
    },
    async toggleStatus(discount) {
      try {
        await axios.post(
          `/api/admin/category-brand-discounts/${discount.id}/status`,
          { status: !discount.status },
          { headers: this.getAuthHeaders() }
        );
        discount.status = !discount.status;
        this.showSuccess('Статус обновлен');
      } catch (error) {
        console.error('Error updating status:', error);
        this.showError('Ошибка обновления статуса');
      }
    },
    async deleteDiscount(discount) {
      if (!confirm('Удалить скидку?')) return;
      try {
        await axios.delete(`/api/admin/category-brand-discounts/${discount.id}`, {
          headers: this.getAuthHeaders(),
        });
        this.discounts = this.discounts.filter(d => d.id !== discount.id);
        this.showSuccess('Скидка удалена');
      } catch (error) {
        console.error('Error deleting discount:', error);
        this.showError('Ошибка удаления');
      }
    },
    resetForm() {
      this.form = {
        id: null,
        category_id: null,
        brand_id: null,
        customer_group_id: 0,
        priority: 1,
        percentage: 0,
        affect_parent: false,
        min_quantity: 0,
        status: true,
        date_start: null,
        date_end: null,
      };
    },
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('ru-RU');
    },
    getAuthHeaders() {
      const token = localStorage.getItem('token');
      return { Authorization: `Bearer ${token}` };
    },
    showSuccess(message) {
      // Show success notification
      alert(message);
    },
    showError(message) {
      // Show error notification
      alert(message);
    },
  },
};
</script>

<style scoped>
.badge {
  padding: 5px 10px;
  font-size: 12px;
}
.badge-success {
  background-color: #28a745;
  color: white;
}
.badge-danger {
  background-color: #dc3545;
  color: white;
}
</style>
